<div mat-dialog-content>
  <h3>Confirmation</h3>
  <div class="confirmation-content">
    <div class="image-container">
      <img
        src="../../../../assets/weDraw-Images/undraw_completing_gsf8 (1).svg"
        alt="Checkmark woman figure"
      />
    </div>
    <div class="confirmation-details">
      <h4>You have successfully purchased {{ data.productName || "N/A" }}</h4>
      <h5>Subscription Id:</h5>
      <p *ngIf="data.subscriptionId">#{{ data.subscriptionId }}</p>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button
    mat-raised-button
    mat-dialog-close
    color="primary"
    [routerLink]="['/landing']"
  >
    Home
  </button>
  <button
    mat-raised-button
    mat-dialog-close
    [routerLink]="['/active-subscription']"
    [queryParams]="{ maxioSubId: data.subscriptionId }"
  >
    Manage Subscription
  </button>
</div>
